// models/avoirAPI.js

import axios from 'axios';

const API_BASE_URL = `${process.env.REACT_APP_API_BASE_URL}/av`;

export const createAvoir = (avoirData) => 
  axios.post(`${API_BASE_URL}/createavoir`, avoirData);

export const saveAvoir = (avoirData) =>
  axios.post(`${API_BASE_URL}/saveavoir`, avoirData);

export const changeAvoirRef = (oldRefAvoir, newRefAvoir) =>
  axios.post(`${API_BASE_URL}/changeref`, { oldRefAvoir, newRefAvoir });


export const validateAvoir1 = (refAvoir) =>
  axios.post(`${API_BASE_URL}/validate1/${refAvoir}`);

export const validateAvoir3 = (refAvoir) =>
  axios.post(`${API_BASE_URL}/validate3/${refAvoir}`);

export const getAvoirById = (id) =>
  axios.get(`${API_BASE_URL}/avoir/${id}`);

export const updateAvoir = (id, avoirData) =>
  axios.put(`${API_BASE_URL}/updateavoir/${id}`, avoirData);

export const deleteAvoir = (id) =>
  axios.delete(`${API_BASE_URL}/deleteavoir/${id}`);

export const getAllAvoir = () =>
  axios.get(`${API_BASE_URL}/getallavoir`);

export const addItemToAvoir = (refAvoir, itemData) =>
  axios.post(`${API_BASE_URL}/additem/${refAvoir}`, itemData);

export const deleteItemFromAvoir = (refAvoir, codeArt) =>
  axios.delete(`${API_BASE_URL}/deleteitem/${refAvoir}/${codeArt}`);

export const updateItemInAvoir = (refAvoir, codeArt, itemData) =>
  axios.put(`${API_BASE_URL}/modifyitem/${refAvoir}/${codeArt}`, itemData);

export const getItemsInAvoir = (refAvoir) =>
  axios.get(`${API_BASE_URL}/getallitems/${refAvoir}`);

export const unvalidateAvoir = (refAvoir) =>
  axios.post(`${API_BASE_URL}/unvalidate/${refAvoir}`);

export const getAvoirItemsPriceHistory = (compte, codeArts, years = 3) =>
  axios.post(`${API_BASE_URL}/priceHistory/${compte}`, { codeArts, years });

// Demarque API
export const listDemarques = (params) =>
  axios.get(`${API_BASE_URL}/demarque`, { params });

export const createDemarque = (data) =>
  axios.post(`${API_BASE_URL}/demarque`, data);

export const getDemarque = (ref) =>
  axios.get(`${API_BASE_URL}/demarque/${ref}`);

export const updateDemarque = (ref, data) =>
  axios.put(`${API_BASE_URL}/demarque/${ref}`, data);

export const deleteDemarque = (ref) =>
  axios.delete(`${API_BASE_URL}/demarque/${ref}`);

export const validateDemarque = (ref) =>
  axios.post(`${API_BASE_URL}/demarque/${ref}/validate`);

export const unvalidateDemarque = (ref) =>
  axios.post(`${API_BASE_URL}/demarque/${ref}/unvalidate`);

// CorrectionStock API
export const listCorrectionStocks = (params) =>
  axios.get(`${API_BASE_URL}/correction-stock`, { params });

export const createCorrectionStock = (data) =>
  axios.post(`${API_BASE_URL}/correction-stock`, data);

export const getCorrectionStock = (ref) =>
  axios.get(`${API_BASE_URL}/correction-stock/${ref}`);

export const updateCorrectionStock = (ref, data) =>
  axios.put(`${API_BASE_URL}/correction-stock/${ref}`, data);

export const deleteCorrectionStock = (ref) =>
  axios.delete(`${API_BASE_URL}/correction-stock/${ref}`);

export const validateCorrectionStock = (ref) =>
  axios.post(`${API_BASE_URL}/correction-stock/${ref}/validate`);

export const unvalidateCorrectionStock = (ref) =>
  axios.post(`${API_BASE_URL}/correction-stock/${ref}/unvalidate`);

// Seed DBF upload APIs
export const uploadAvoirsDBF = (formData) =>
  axios.post(`${API_BASE_URL}/seed/upload-avoirs`, formData, {
    headers: {
      'Content-Type': 'multipart/form-data'
    }
  });

export const uploadAvoirsDetailsDBF = (formData) =>
  axios.post(`${API_BASE_URL}/seed/upload-details`, formData, {
    headers: {
      'Content-Type': 'multipart/form-data'
    }
  });

export const uploadBothAvoirsDBF = (formData) =>
  axios.post(`${API_BASE_URL}/seed/upload-both`, formData, {
    headers: {
      'Content-Type': 'multipart/form-data'
    }
  });

// Demarque Seed DBF upload APIs
export const uploadDemarqueDBF = (formData) =>
  axios.post(`${API_BASE_URL}/seed/upload-demarque`, formData, {
    headers: {
      'Content-Type': 'multipart/form-data'
    }
  });

export const uploadDemarqueDetailsDBF = (formData) =>
  axios.post(`${API_BASE_URL}/seed/upload-demarque-details`, formData, {
    headers: {
      'Content-Type': 'multipart/form-data'
    }
  });

export const uploadBothDemarqueDBF = (formData) =>
  axios.post(`${API_BASE_URL}/seed/upload-demarque-both`, formData, {
    headers: {
      'Content-Type': 'multipart/form-data'
    }
  });